<template>
    <div class="t_content_view">
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">渠道类别：</span>
                <el-select size="small"
                 style="width: 180px;"
                @change="searchselect"
                v-model="searchdata.channel_type_id" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.channel_title" placeholder="请输入渠道名称"  clearable />
            </div>
            <el-button style="margin-bottom: 10px;" @click="resetsearch" color="#F1F3F9" type="primary">重置</el-button>
        </div>
        <el-button color="#4F46E5" class="t_add_people" type="primary" @click="addqd(1,'')" >新建渠道</el-button>
        <router-link :to="{path:'/navtkyl/qdtype'}">
            <el-button style="margin-left:10px" color="#4F46E5" class="t_add_people" type="primary">渠道类别管理</el-button>
        </router-link>
        
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            <el-table-column prop="title" label="渠道名称">
            </el-table-column>
            <el-table-column prop="channel_type_title" label="渠道类别" />
            <el-table-column prop="created_by" label="创建人" />
            <el-table-column prop="tage" label="标签">
                <template #default="scope">
                    <el-tag v-for="(item,index) in scope.row.tagName" 
                    :key="index"
                    style="margin-right:5px;margin-bottom:5px"
                    type="success">{{item}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="updated_at" label="创建时间" />

            <el-table-column label="操作">
                <template #default="scope">
                    <el-button style="color:#4F46E5" size="small" type="text" @click="addqd(2, scope.row)">编辑</el-button>
                    <el-button style="color:#4F46E5" size="small" type="text" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    <!-- 新增渠道 -->
    <el-dialog v-model="isaddqd" title="新增/编辑渠道" width="500px" >
        <el-form  label-width="120px">
            <el-form-item label="所属渠道类别：">
                <el-select style="width:100%;margin-right: 0;" class="t_search_select" size="small" 
                v-model="addlist.qdtype"
                value-key="id"
                placeholder="请选择渠道类别">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="{ id: item.id,title:item.title}" />
                </el-select>
            </el-form-item>
            <el-form-item label="渠道名称：">
                <el-input placeholder="请输入渠道名称" v-model="addlist.qdname"  clearable />
            </el-form-item>
            <el-form-item label="渠道标签：" >
                <!-- <div>
                    <el-button color="#4F46E5" @click="choosetag" type="primary"  >选择标签</el-button>
                    <div>
                        <el-tag
                        closable
                        class="t_choosedtag"  v-for="(item,index) in choosedtag.data" :key="index"
                        @close="handleClose(item,index)"
                        type="success">{{item.title}}
                        </el-tag>
                    </div>
                </div> -->
                 <chooseTag :choosedtag="choosedtag" :bqData="bqData" @changechoosedtag="changechoosedtag"
                 @changebqData = 'changebqData'
                 />
            </el-form-item>
        </el-form>
        <div class="t_cz_box">
            <el-button @click="addrest" >取消</el-button>
            <el-button color="#4F46E5"  @click="addsub" type="primary">确定</el-button>
        </div>
    </el-dialog>
    <!-- 选择标签 -->
    <!-- <el-dialog v-model="isqdtag" title="选择渠道标签" width="500px" >
        <div class="t_tagchoose_box" v-for="(item,index) in bqData.data" :key="index">
            <div>{{item.title}}</div>
            <div>
                <el-check-tag v-for="(item2,index2) in item.tagList" :key="index2" 
                class="t_all_tag"
                :checked="item2.checked" @change="onChange(index,index2)">{{item2.title}}</el-check-tag>
            </div>
        </div>
        <div class="t_cz_box">
            <el-button color="#4F46E5" @click="choosesub" type="primary">确定</el-button>
        </div>
    </el-dialog> -->
</template>
<script setup> 
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { bqlist,qdtypelist,qdmlist,addqdm,changeqdm,delqdm,newgettaglist,newqdlist,newaddqudao,neweditqudao,newqudaolist ,newdelqudao} from '@/assets/js/common.js'
//导入子组件
import pagechange from '../components/pagechange.vue'
import chooseTag from '../components/chooseTag.vue';
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //获取标签列表
    getbqlist()
    //渠道类别列表，用于下拉
    getqdtypelist()
    //获取列表数据
    getlist()
})

//////////////////////////////////

//选择标签组件需要的数据

//选中的标签数组
const choosedtag = reactive({
    data:[]
})
//监听子组件传来的数据
const changechoosedtag = (e)=>{
    choosedtag.data = e
}
// 全部标签
const bqData = reactive({
    data:[]
})
//监听子组件传来的数据
const changebqData = (e)=>{
    bqData.data = e
}
//获取标签列表
const getbqlist = ()=>{
    newgettaglist().then((response)=>{
        // console.log(response)
        if (response.data.msg.code == 0) {
            bqData.data = response.data.data
            //添加是否选中状态
            for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    bqData.data[i].tags[x].checked=false
                }
            }
        }
    })
}
////////////////////////////////
// 全部标签
// const bqData = reactive({
//     data:[]
// })

//切换标签选中事件
// const onChange = (i1,i2)=>{
//     bqData.data[i1].tagList[i2].checked=!bqData.data[i1].tagList[i2].checked
// }
//搜索下拉数据
const options = reactive({
    data:[]
})
//渠道类别列表，用于下拉
const getqdtypelist = ()=>{
    newqdlist().then((response)=>{
        console.log(response)
        if (response.data.msg.code == 0) {
            options.data=response.data.data
        }
    })
}

//列表数据
const tableData = reactive({
    data:[]
})
//成员总数
const total = ref(0)
//搜索
const searchdata = reactive({
   //当前页
    page:1,
    page_size:20,
    channel_title:'',
    channel_type_id:''
})
//下拉框内容发生改变
const searchselect = (val)=>{
    console.log(val)
    searchdata.page=1
    searchdata.channel_type_id=val
    getlist()
}
//搜索输入框内容改变
const searchinput = (val)=>{
    searchdata.page=1
    searchdata.channel_title=val
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.page=1
    searchdata.channel_title=''
    searchdata.channel_type_id=''
    getlist()
}
//获取列表数据
const getlist = ()=>{
    newqudaolist(searchdata).then((response)=>{
        console.log('获取列表')
        console.log(response.data.data)
        if (response.data.msg.code == 0) {
            tableData.data=response.data.data.data
            //将字符串转数组
            for(var i=0;i<tableData.data.length;i++){
                tableData.data[i].tagId=tableData.data[i].tag_ids
                tableData.data[i].tagName=tableData.data[i].tag_titles
            }
            total.value = response.data.data.total
        }
        
    })
}
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//新增字段
const addlist = reactive({
    qdtype:'',
    qdname:''
})
//新增弹窗是否显示
const isaddqd = ref(false)
//当前操作是新增还是编辑
const addtype = ref('')
//当前操作id
const nowid = ref('')
//点击新增渠道
const addqd = (type,row)=>{
    isaddqd.value=true
    addtype.value = type
    nowid.value = row.id
    //添加是否选中状态
    for(var i=0;i<bqData.data.length;i++){
        for(var x=0;x<bqData.data[i].tags.length;x++){
            bqData.data[i].tags[x].checked=false
        }
    }
    if(type==1){
        //新增
        addlist.qdname=''
        addlist.qdtype={
            id:'',
            // title:'',
        }
        choosedtag.data=[]
    }else if(type==2){
        //编辑
        choosedtag.data=[]
        addlist.qdname=row.title
        addlist.qdtype={
            id:row.channel_type_id,
            // title:row.categoryName,
        }
        console.log('==--==')
        console.log(bqData.data)
        for(var i=0;i<bqData.data.length;i++){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                for(var y=0;y<row.tagId.length;y++){
                    if(bqData.data[i].tags[x].id==row.tagId[y]){
                        bqData.data[i].tags[x].checked=true
                        choosedtag.data.push(bqData.data[i].tags[x])
                    }
                }
            }
        }
        console.log(choosedtag.data)
        
        
    }
}
//取消新增
const addrest = ()=>{
    isaddqd.value=false
}
//提交新增
const addsub = ()=>{
    //提交新增    
    var tagIds = []
    // var tagName = ''
    for(var i=0;i<choosedtag.data.length;i++){
        console.log(choosedtag.data[i])
        tagIds.push(choosedtag.data[i].id)
        // tagName=tagName+choosedtag.data[i].title+','
    }
    // tagId=tagId.substr(0,tagId.length-1)
    // tagName=tagName.substr(0,tagName.length-1)
 
        if(addtype.value==1){
            //新增
            newaddqudao({
                title:addlist.qdname,
                channelTypeId:addlist.qdtype.id,
                // categoryName:addlist.qdtype.title,
                tagIds:tagIds,
                // tagName:tagName
            }).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '新增成功！',
                    })
                    isaddqd.value=false
                    getlist()
                }
            })
        }else if(addtype.value==2){
            //编辑
            neweditqudao({
                id:nowid.value,
                title:addlist.qdname,
                channelTypeId:addlist.qdtype.id,
                // categoryName:addlist.qdtype.title,
                tagIds:tagIds,
                // tagName:tagName
            }).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '修改成功！',
                    })
                    isaddqd.value=false
                    getlist()
                }
            })
        }
}
//删除
const handleDelete = (row)=>{
    ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelqudao({id:row.id}).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    type: 'success',
                    message: '删除成功！',
                })
                getlist()
            }
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//选择渠道标签弹窗
// const isqdtag = ref(false)
// const choosetag = ()=>{
//     isqdtag.value=true
// }




//确定选择
// const choosesub = ()=>{
//     // isqdtag.value=false
//     choosedtag.data=[]
//     for(var i=0;i<bqData.data.length;i++){
//         for(var x=0;x<bqData.data[i].tagList.length;x++){
//             if(bqData.data[i].tagList[x].checked){
//                 choosedtag.data.push(bqData.data[i].tagList[x])
//             }
//         }
//     }
//     console.log(choosedtag.data)
// }
//删除选中标签
// const handleClose = (item,index)=>{
//     console.log(item)
//     choosedtag.data.splice(index, 1)
//     //将选中状态修改为未选中状态
//     for(var i=0;i<bqData.data.length;i++){
//         //找到父级
//         if(bqData.data[i].id==item.groupId){
//             for(var x=0;x<bqData.data[i].tagList.length;x++){
//                 //找到子集
//                 if(bqData.data[i].tagList[x].id==item.id){
//                     //改为未选中
//                     bqData.data[i].tagList[x].checked=false
//                 }
//             }
//         }
        
//     }
// }



</script>
<style scoped>

:deep( .t_search_select .select-trigger){
    width:100%
}

:deep( .el-input__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

/* .t_content_view {
    padding: 20px;
} */
/* .t_cz_box{
    display: flex;
    justify-content:space-around
} */
.t_all_tag{
    margin-top: 10px;
    margin-right: 10px;
}
.t_tagchoose_box{
    margin-bottom:30px
}
.t_choosedtag{
    margin-right:10px;
    margin-bottom:10px;
    
}
:deep(.t_search_box .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
    width:100%
}

</style>